// extracted by mini-css-extract-plugin
export var dividerContainer = "_9o-0";
export var line = "_9o-1";